import {useQuery} from "@tanstack/react-query";
import {useIntl} from "react-intl";
import {publicTaxiOrderConfiguration} from "@/api/apiClient";
import {usePublicOrderHash} from "@/features/configuration/hooks/usePublicOrderHash";
import {
    handlePublicHashError,
    isNonRetryableError,
} from "@/features/configuration/utils/error-handling";

export function useConfiguration() {
    const {clearOrderHash, isInitialized, orderHash} = usePublicOrderHash();
    const intl = useIntl();
    return useQuery({
        queryKey: ["configuration", {orderHash}],
        queryFn: async () => {
            const hash = orderHash ?? undefined;
            try {
                const response = await publicTaxiOrderConfiguration(hash);
                return response;
            } catch (error) {
                handlePublicHashError(error, intl, clearOrderHash);
                throw error;
            }
        },
        enabled: isInitialized,
        retry: (failureCount, error) => {
            if (isNonRetryableError(error)) return false;
            return failureCount < 3;
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
}
